import SVGelem from '@components/SVGelem/SVGelem';
import closeBtn from '@images/renders/icon_images/closeBtn.svg';
import cn from 'classnames';
import SVG from 'react-inlinesvg';
import style from './ButtonClose.module.scss';

function ButtonClose({ id, className, handleFuction }) {
  switch (id) {
    case 'close_black': {
      return (
        <button className={cn(style.buttonClose, className)} onClick={handleFuction} data-testid='formClose'>
          <SVG src={closeBtn.src} className={style.svg} />
        </button>
      );
    }
    case 'close_white': {
      return (
        <button className={cn(style.buttonClose, className)} onClick={handleFuction} data-testid='formClose'>
          <SVGelem href='#close-white' className={style.buttonCloseIconWhite} />
        </button>
      );
    }
    default: {
      return null;
    }
  }
}

export default ButtonClose;
